<template>
  <!-- 头像选择组件 -->
  <div class="avatar">
    <div class="Upload-box" v-loading="loading">
      <img :src="imgSrc" alt="" v-if="imgSrc != ''" />
      <input type="file" ref="clearFile" @change="onFileChange" id="file" />
      <input type="button" value="+" class="btn" v-if="imgSrc == ''" />
    </div>
    <div class="avatar-select">
      <!-- 多个可选择头像 -->
      <div v-for="(item, index) in avatarArr" :key="index">
        <img class="firm-clickable" :src="item" alt="" @click="handelClickImg(item)" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSysDefaultUserImg, // 发送短信，邮箱验证码
} from "../assets/api/index";

export default {
  // 组件名称
  name: "Login",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      avatarArr: [], // 可供选择的 头像数组
      imageUrl: "", // 头像路径
      imgSrc: "",
      loading: false,
      TXurl: "", //上传到腾讯云的地址
    };
  },
  // 组件初始化
  created() {
    this.getSysDefaultUserImg();
  },
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {},
  // 组件方法
  methods: {
    clickFile() {
      const input = document.querySelector("#file");
      input.click();
    },
    async onFileChange(event, opt, callback) {
      this.loading = true;
      var file = event.target.files[0] || event.dataTransfer.files[0];
      var fileSuffix1 = file.name;
      var fileArr = fileSuffix1.split(".");
      var fileSuffix = fileArr[fileArr.length - 1]; // 获取上传文件的后缀确认是否符合要求
      if (fileSuffix == "jpg" || fileSuffix == "png") {
        let URL = window.URL || window.webkitURL; // 当前地址
        var arr = await this.$tool.onFileChangeNew(event, opt, callback);
        console.log(arr, "arr");
        if (arr.code == 0) {
          this.loading = false;
          this.TXurl = arr.TXurl;
          this.imgSrc = URL.createObjectURL(file); // 转成 blob地址  用于上传后图片在页面中回显
        } else {
          this.loading = false;
        }
        this.$refs.clearFile.value = ""; // 清空file文件
      } else {
        // 上传文件不符合要求
        this.loading = false;
        this.$tool.PromptBox("error", "请上传jpg/png文件");
      }
    },

    async getSysDefaultUserImg() {
      var data = {};
      // 调接口
      const res = await getSysDefaultUserImg(data);
      console.log(res);
      this.avatarArr = res.data;
      this.imgSrc = res.data[0];
      this.TXurl = res.data[0];
      this.$emit("handleAvatarTxUrl", res.data[0]);
    },

    // 点击头像
    handelClickImg(item) {
      this.imgSrc = item;
      this.TXurl = item;
      this.$emit("handleAvatarTxUrl", this.TXurl);
    },
  },
};
</script>

<style scoped lang="less">
.avatar {
  width: 100%;
  height: 100%;
  display: flex;
  .Upload-box {
    width: 90px;
    height: 90px;
    border: 1px dashed #409eff ;
    margin-right: 20px;
    display: flex;
    img {
      width: 100%;
      height: 100%;
    }
    #file {
      display: none;
    }
    #file1 {
      display: none;
    }
    input {
      border: none;
      box-shadow: none;
      outline: none;
      background-color: transparent;
      width: 100%;
      text-align: center;
      color: #409eff ;
      // margin-top: 40px;
      margin: auto 0;
      font-size: 26px;
    }
  }
  .avatar-select {
    width: 180px;
    height: 95px;
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    div {
      width: 40px;
      height: 40px;
      margin: auto;
      border-radius: 50%;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
